import type {
  BadgeColour,
  WidgetConfigBackgroundMode,
  WidgetConfigBehaviour,
  WidgetConfigIconSize,
  WidgetConfigIconStyle,
  WidgetConfigTextMode,
  WidgetSizePreset,
} from "@s2z-platform/constants";
import type { HexColour } from "../../../common";

export class WidgetStylingConfigJSON {
  iconStyle: WidgetConfigIconStyle;
  iconSize: WidgetConfigIconSize;
  backgroundMode: WidgetConfigBackgroundMode;
  backgroundColour: HexColour;
  badgeColour: BadgeColour;
  textMode: WidgetConfigTextMode | null;
  textColour: HexColour;
  backgroundImageId: number | null;
  size?: {
    // s = 1 scale, m = 2 scale, l = 3 scale
    preset: WidgetSizePreset;
    customScale: number;
    // BANANAL obsolete! Should be removed in next widget enhancment!
    dynamicScaling?: boolean;
  } | null;
  behaviour?: WidgetConfigBehaviour | null;
  hideBorder?: boolean;
  borderRadius?: boolean;
}
